import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
    render() {
        return (
          <section className="footer pt-120">
            <div className="container">
              <div className="row">
                <div className="col-lg-4 me-auto col-sm-6 col-md-12">
                  <div className="widget footer-widget mb-5 mb-lg-0">
                    <h5 className="widget-title">Storyteller Group</h5>
                    <p className="mt-3">
                      Member:
                      <br />
                      Ricky Yakobus Kota (Student ID: 343249206)
                      <br />
                      Diah Galuh Sarimbit (Student ID: 34308059)
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 col-sm-6 col-md-12">
                  <div className="footer-widget mb-5 mb-lg-0">
                    <h5 className="widget-title">Information</h5>
                  </div>
                  <div className="row">
                    <div className="col-lg-5 col-md-6">
                      <ul className="list-unstyled footer-links">
                        <li>
                          <Link to="#">Ricky's Email</Link>
                        </li>
                        <li>
                          <Link to="#">Galuh's Email</Link>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="footer-widget footer-contact mb-5 mb-lg-0">
                        <ul className="list-unstyled">
                          <li>rkot0010@student.monash.edu</li>
                          <li>dsar0022@student.monash.edu</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="fixed-btm-top">
              <a href="#top-header" className="js-scroll-trigger scroll-to-top">
                <i className="fa fa-angle-up"></i>
              </a>
            </div>
          </section>
        );
    }
}

export default Footer;
